import styled from "styled-components";

export const ChipStyled = styled.div`
  background: #c9e5b5;
  border-radius: var(--corner-radius-999, 999px);
  font-size: var(--font-size-button-sm, 14px);
  font-style: normal;
  font-weight: 500;
  line-height: var(--font-line-height-button-sm, 18px);
  margin-left: 8px;
  padding: 3px 6px;
`;
